import { getDashboardApi } from "../Components/constant/Api";
import { myApi } from "./api";

export const dashboardApi = myApi.injectEndpoints({
  endpoints: (builder) => ({
    getDashboard: builder.query({
      query: () => getDashboardApi, // simpler GET

      transformResponse: (response) => {
        if (!response?.status) return null;
        return response?.data?.[0] ?? null;
      },

      providesTags: ["dashboard"],
    }),
  }),
});

export const { useGetDashboardQuery } = dashboardApi;
